import React from 'react';

const DealershipListColumns = () => [
  { accessorKey: 'dealershipId', header: 'ID', size: 60, minSize: 40, maxSize: 80 },
  { accessorKey: 'dealershipName', header: 'Name', size: 200, minSize: 150, maxSize: 300 },
  { accessorKey: 'city', header: 'City', size: 120, minSize: 80, maxSize: 160 },
  { accessorKey: 'state', header: 'State', size: 100, minSize: 60, maxSize: 140 },
  { accessorKey: 'country', header: 'Country', size: 100, minSize: 60, maxSize: 140 },
  { accessorKey: 'timezone', header: 'Timezone', size: 160, minSize: 100, maxSize: 200 },
  { accessorKey: 'hubspotId', header: 'Hubspot ID', size: 120, minSize: 80, maxSize: 160 },
  { accessorKey: 'source', header: 'Source', size: 100, minSize: 60, maxSize: 140 },
  { accessorKey: 'leadPipeline', header: 'Lead Pipeline', size: 140, minSize: 100, maxSize: 180 },
  { accessorKey: 'accountOwner', header: 'Account Owner', size: 160, minSize: 120, maxSize: 200 },
  { accessorKey: 'segment', header: 'Segment', size: 120, minSize: 80, maxSize: 160 },
  { accessorKey: 'accountType', header: 'Account Type', size: 130, minSize: 100, maxSize: 160 },
  { accessorKey: 'locationType', header: 'Location Type', size: 130, minSize: 100, maxSize: 160 },
  { accessorKey: 'launchMilestone', header: 'Launch Milestone', size: 150, minSize: 120, maxSize: 180 },
  { accessorKey: 'lifeCycleStage', header: 'Life Cycle Stage', size: 150, minSize: 120, maxSize: 180 },
  { accessorKey: 'organizationSize', header: 'Org Size', size: 120, minSize: 80, maxSize: 160 },
  {
    accessorKey: 'enabled',
    header: 'Enabled',
    size: 80,
    minSize: 60,
    maxSize: 100,
    Cell: ({ cell }) => <span>{cell.getValue() === 'yes' || cell.getValue() === true ? 'Yes' : 'No'}</span>,
  },
];

export default DealershipListColumns;
